
import * as React from 'react'
import * as ReactHighcharts from 'react-highcharts'
import { IPeerGroupTabsProps, ISeries, IFilter, IVisualizationState, roundNumber } from '../../lib/http'
import { Panel } from 'react-bootstrap'
import { Visualization14 } from '../Visualization14'

export class Visualization15 extends React.Component<IPeerGroupTabsProps, IVisualizationState> {
  state: IVisualizationState = {
    series: [],
    title: 'Hello World',
    loading: false,
    filters: { assetLevel: -1 },
    data: []
  }

  componentDidMount() {
    this.setState({ data: this.props.data }, () => this.loadSeries(this.props.filters))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel || prevProps.data.length !== this.props.data.length) {
      this.setState({ filters: this.props.filters, data: this.props.data }, () => {
        this.loadSeries(this.props.filters)
      })
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state
    let title = ''
    const series = []
    let innerSize = 280
    let size = 290
    data.map((dataPoint, index) => {
      title = dataPoint.OpEx_T_V15_Vis15Title

      series.push({
        name: dataPoint.OpEx_T_V15_Vis15Column,
        innerSize,
        size,
        data: [{ color: '#A9D08E', name: dataPoint.OpEx_T_V15_Label_OpEX, y: roundNumber(dataPoint.OpEx_N_V15_TotExpPct * 100.0, 1) },
        { color: '#B4C6E7', name: dataPoint.OpEx_T_V15_LabelGrants, y: roundNumber(dataPoint.OpEx_N_V15_GrantsPct * 100.0, 1) }]
      })

      innerSize -= 10
      size -= 10
    })

    this.setState({ title, series })
  }

  static getChartConfig(series: ISeries[]) {
    const title = ''
    return {
      chart: { type: 'pie', height: 300 },
      title: {
        text: title
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true
        }
      },
      tooltip: {
        valueSuffix: '%'
      },
      legend: { enabled: false, },
      credits: { enabled: false },
      series
    }
  }

  render() {
    const { series, title, loading } = this.state
    return (
      <Panel>
        <div className="panel-body text-center">
          {title}{loading && <i className="fa fa-cog fa-spin"></i>}<br />
          <small><i className="fa fa-circle" style={{ color: '#A9D08E' }}></i>&nbsp;Operating Expenses</small>&nbsp;&nbsp;
          <small><i className="fa fa-circle" style={{ color: '#B4C6E7' }}></i>&nbsp;Grants</small><br />
        </div>
        <div className="panel-body">
          <ReactHighcharts config={Visualization15.getChartConfig(series)} ref="chart" />
        </div>
      </Panel>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/OperatingExpenses/Visualization15/index.tsx